import { Schema } from "./types";

export const generateCURLSnippet = (deployment_id: string, workspaceKey: string, requestSchema: Schema) => {
  return `curl -X 'POST' \
  '${import.meta.env.VITE_API_SERVICE_URL}/v1/deployment/${deployment_id}/run' \
  -H 'accept: application/json' \
  -H 'Authorization: Bearer ${workspaceKey}' \
  -H 'Content-Type: application/json' \
  -d '{
  "input": ${JSON.stringify(
    requestSchema
      .map((field) => ({
        [field.fieldName]: "",
      }))
      .reduce((acc, curr) => ({ ...acc, ...curr }), {}),
  )}
}'`;
};

export const generateOpenAPISnippet = (
  deployment_id: string,
  _workspaceKey: string,
  requestSchema: Schema,
  responseSchema: Schema,
) => {
  return `openapi: 3.1.0
info:
  title: Prompt Studio API
  description: Run Promptbooks on Prompt Studio.
  version: 1.0.0
servers:
  - url: ${import.meta.env.VITE_API_SERVICE_URL}/api
paths:
  /v1/instructions/${deployment_id}/run:
    post:
      summary: <DESCRIPTION SUMMARY> 
      description: <DESCRIPTION>
      operationId: <OPERATION_ID>
      requestBody:
        required: true
        content:
          application/json:
            schema:
              type: object
              properties:
                input:
                  type: object
                  properties:
                    ${requestSchema
                      .map(
                        (field) => `${field.fieldName}:
                      type: string
                      description: <FIELD DESCRIPTION>`,
                      )
                      .join("\n")}
      responses:
        "200":
          description: <RESPONSE DESCRIPTION>
          content:
            application/json:
              schema:
                type: object
                properties:
                ${responseSchema
                  .map(
                    (field) => `${field.fieldName}:
                    type: string
                    description: <FIELD DESCRIPTION>
                    example: <RESPONSE EXAMPLE>`,
                  )
                  .join("\n")}
  `;
};

export const generateCodeSnippet = (
  type: string,
  deployment_id: string,
  workspaceKey: string,
  requestSchema: Schema,
  responseSchema: Schema,
) => {
  switch (type) {
    case "cURL":
      return generateCURLSnippet(deployment_id, workspaceKey, requestSchema);
    case "OpenAPI":
      return generateOpenAPISnippet(deployment_id, workspaceKey, requestSchema, responseSchema);
    default:
      return generateCURLSnippet(deployment_id, workspaceKey, requestSchema);
  }
};
